import { JsonConvert, JsonConverter, JsonCustomConvert, JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "../base-response";

@JsonConverter
export class LicenseListConverter implements JsonCustomConvert<LicenseList> {
  serialize() { }
  deserialize(data: any): LicenseList {
    const license = new LicenseList();
    license.licenseId = data?.licenseId ?? "";
    license.licenseKey = data?.licenseKey ?? "";
    license.generateDate = Number(data?.generateDate ?? 0);
    license.duration = Number(data?.duration ?? 0);
    license.companyName = data?.companyName ?? "";
    license.enabled = Boolean(data?.enabled);
    return license;
  }
}

@JsonConverter
export class LicenseListArrayConverter implements JsonCustomConvert<Array<LicenseList>> {
    serialize() { }
    deserialize(data: any): Array<LicenseList> {
      const converter = new LicenseListConverter();
      return (data ?? []).map((item: any) => converter.deserialize(item));
    }
}

@JsonConverter
export class LicenseListListConverter implements JsonCustomConvert<LicenseCountList> {
    serialize() { }
    deserialize(data: any): LicenseCountList {
      const list = new LicenseCountList();
      list.count = Number(data?.count ?? 0);
      list.items = new LicenseListArrayConverter().deserialize(data?.items ?? data?.data ?? []);
      return list;
    }
}

@JsonObject("LicenseList")
export class LicenseList {

  @JsonProperty("licenseId", String, true)
  licenseId: string = "";
  @JsonProperty("licenseKey", String, true)
  licenseKey: string = "";
  @JsonProperty("generateDate", Number, true)
  generateDate: number = 0;
  @JsonProperty("duration", Number, true)
  duration: number = 0;
  @JsonProperty("companyName", String, true)
  companyName: string = "";
  @JsonProperty("enabled", Boolean, true)
  enabled: boolean = false;
}

@JsonObject("LicenseCountList")
export class LicenseCountList {
    @JsonProperty("count", Number, true)
    count: number = 0;
    items: Array<LicenseList> = [];
}

@JsonObject("LicenseListData")
export class LicenseListData extends BaseResponse {
    @JsonProperty("data", LicenseListConverter, true)
    data: LicenseList = new LicenseList();
}

@JsonObject("LicenseListDataArray")
export class LicenseListDataArray extends BaseResponse {
    @JsonProperty("data", LicenseListListConverter, true)
    data: LicenseCountList = new LicenseCountList();
} 
